import React, { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import HistoryIcon from '@mui/icons-material/History';
import { Link, useNavigate, useParams } from 'react-router-dom';
import S from './ListDam.module.css'
import D from '../images/history.svg'

import {  useSelector } from 'react-redux';

import Gadjet from '../images/gadjet.svg'

import apiService from '../api/ApiService';
import { useGlobalContext } from '../Components/Context';
import CattleHistoryCompare from '../Components/HistoryCompare/CattleHistoryCompare';
import { DateRange, DateRangeRounded, KeyboardBackspace, Report, Sell, Sensors, SplitscreenOutlined } from '@mui/icons-material';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { Pagination } from '@mui/material';
import useHistory from '../Components/CustomHooks/useHistory';
import CattleHistoryParameterCard from '../Components/cardThemes/cattleHistoryParameterCard';
import EmptyReturn from '../Components/EmptyReturn';
const moment=require('moment-jalaali')
export default function ListCattleParamHistory() {
  const {currentTheme}=useSelector(state=>state.p.admin)

  const flag='cattleParameter'
  const navigate=useNavigate(apiService.getCattleHistoryParameters)
  const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
  const {total,page,handlePage,data,SData,setSdata,selectedDayRange, setSelectedDayRange,renderCustomInput}=useHistory(flag)

  return (
    <div className={S.AllAnimalssLICon}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} style={{width:'70px',height:'70px'}} src={D}/>
        <h2> تاریخچه پارامتر های دام</h2>
        </div>
        <div onClick={()=>{navigate(-1)}}  className='backButton' >
          <KeyboardBackspace fontSize='large'/>
        </div>
       
           
      </div>
        <hr/>
        <div class="inputContainerSS">
                           <DatePicker
                           value={selectedDayRange}
                           onChange={setSelectedDayRange}
                             locale='fa'
                             calendarClassName="birthCalender"
                             renderInput={renderCustomInput}
                             />
                             
                           
                              
                       </div>
        {!currentTheme&&<div className={S.TabForAllAnnimLICon}>
          
          
          <div className={S.AnimContentLI} data-aos='fade'>
          {data.length?<table>
              <thead>
              <tr>
                  <th>
                  <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div>
                  </th><th>
                  <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                    
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                    
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                    <img style={{width:'20px',height:'20px'}} src={Gadjet}/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                  </th>
                  
                 <th>
                 <div className='LogoFormT'><div><span>
                <Report/>
                </span>
                    </div></div>
                 </th>
                 
                </tr>
                <tr>
                  <th>
                    ردیف
                  </th>
                  <th>
                    شماره سنسور
                  </th>
                  <th>
                    شماره بدن
                  </th>
                  <th>
                    شماره گوش
                  </th>
                  <th>
                    شماره گردنبند
                  </th>
                  <th>
                     تاریخ
                  </th>
                  
                 <th>
                  جزئیات
                 </th>
                 
                </tr>
              </thead>
              <tbody>
                {
                  data?.length&&data?.map((item,index)=>{
                    const {entryDate}=item;
                    const birth=entryDate?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD HH:mm')
                    return <tr key={index}>
                    <td>
                      {index+1}
                    </td>
                    <td>
                      {JSON.parse(item?.newJson)?.Sensor?.DeviceCode}
                    </td>
                    <td>
                      {JSON.parse(item?.newJson)?.BodyNumber}
                    </td>
                    <td>
                      {JSON.parse(item?.newJson)?.EarTagNumber}
                    </td>
                    <td>
                      {JSON.parse(item?.newJson)?.NecklaceNumber?JSON.parse(item?.newJson)?.NecklaceNumber:'---'}
                    </td>
                    <td>
                      {pbirth}
  
                    </td>
                   
                    <td  >
                    <div  onClick={()=>{
                      setSdata(item);openModalls()
                    }} className='btnCardDAm'>مشاهده</div>
                    </td>
                    
                    
                  </tr>
                  
                  })
                }
                
                
                
                
                

              </tbody>
            </table>:<EmptyReturn/>}
          </div>
        </div>}
        {currentTheme&&<CattleHistoryParameterCard data={data}/>}
        <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
        {!currentTheme&&isOpenModal&&<CattleHistoryCompare data={SData?.currentJson} data2={SData?.newJson}/>}
    </div>
  );
}